import React, { useState, useEffect, useCallback } from 'react'
import { useLocation } from '@gatsbyjs/reach-router'
import { motion, useReducedMotion } from 'framer-motion'
import styled from 'styled-components'

// Components
import Footer from 'components/layout/Footer'
import Header from 'components/layout/Header'

// CSS
import 'styles/all.css'
import CustomLink from 'components/shared/CustomLink'

// Theme
import Theme from 'styles/Global'

const Content = styled.div<{ isSticky?: boolean }>`
  padding-top: 90px;
`

const PageTransition = styled(motion.div)`
  width: 100%;
`

const StyledCustomLink = styled(CustomLink)`
  background: ${(props) => props.theme.color.face.contrast};
  position: fixed;
  font-weight: ${(props) => props.theme.font.weight.m};
  color: ${(props) => props.theme.color.text.light};
  top: 0;
  margin: auto;
  right: 25px;
  height: 50px;
  z-index: 1;
  transform: rotate(-90deg);
  transform-origin: center right;
  white-space: nowrap;
  bottom: 0;
  padding: 1rem;
  transition: all 0.1s ease-in-out;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 700;
  border-top-right-radius: 30px;
  z-index: 999;

  &:hover {
    color: ${(props) => props.theme.color.text.secondary};
    right: 20px;
    padding-bottom: 22.2px;
    background-color: ${(props) => props.theme.color.face.light};
  }

  @media (max-width: 991px) {
    display: none !important;
  }
`

interface LayoutProps {
  children: any
}

function Layout({ children }: LayoutProps) {
  const location = useLocation()
  const prefersReducedMotion = useReducedMotion()
  const [isSticky, setSticky] = useState<boolean>(false)
  const [isScrollable, setIsScrollable] = useState<boolean>(true)
  const [isVisible] = useState<boolean>(true)

  const handleScroll = useCallback(() => {
    setSticky(window.scrollY > 0)
  }, [])

  useEffect(() => {
    handleScroll()
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  return (
    <Theme isScrollable={isScrollable}>
      <Header isSticky={isSticky} setIsScrollable={setIsScrollable} />
      <Content isSticky={isSticky}>
        <StyledCustomLink
          to="https://wa.me/31628518801?text=H%C3%A9+Leon%2C"
          target="_blank"
          className={`${isVisible ? 'd-flex' : 'd-none'} text-center px-4`}
        >
          Whatsapp ons
        </StyledCustomLink>
        <PageTransition
          key={`${location.pathname}${location.search}`}
          initial={prefersReducedMotion ? false : { opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.42,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          {children}
        </PageTransition>
      </Content>
      <Footer />
    </Theme>
  )
}

export default Layout
